import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFAB from './components/WhatsAppFAB';
import HomePage from './pages/HomePage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <div className="App bg-[#f7f2ec] text-stone-900 antialiased">
      <CartProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/sepet" element={<CartPage />} />
            <Route path="/odeme" element={<CheckoutPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Footer />
          <WhatsAppFAB />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
